export const keyTranslations = {
    addresS_C_TXT: "Постоянен адрес",
    addresS_P_TXT: "Настоящ адрес",
    chilD_EGN: "ЕГН на дете",
    chilD_NAME: "Име на дете",
    grupA_RESIDENCE: "Група район",
    k10: "П1",
    k20: "П2",
    k30: "П3",
    k40: "П4",
    k50: "П5",
    k60: "П6",
    k70: "П7",
    k80: "П8",
    k90: "П9",
    k100: "П10",
    k110: "П11",
    k120: "П12",
    k130: "П13",
    k140: "П14",
    k150: "П15",
    k160: "П16",
    k170: "П17",
    k180: "П18",
    k190: "П19",
    k200: "П20",
    parenT_NAME: 'Име на родител',
    parenT_PHONE: 'Тел. номер',
    regnumbeR_ID: 'Рег.№',
    status: 'Статус'
};

export const translateKeys = (data) => {
    const translatedData = {};
    for (const key in data) {
        if (key in keyTranslations) {
            translatedData[keyTranslations[key]] = data[key];
        } else {
            translatedData[key] = data[key];
        }
    }
    return translatedData;
}